import { useContext, useEffect } from 'react';
import { OfertasContext } from '../context/ofertas-context';
import { RegisteredDisclaimer } from './get-disclaimer';

export interface RegisteredDisclaimers {
	[key: string]: RegisteredDisclaimer;
}

export interface NamedDisclaimer {
	readonly ref: string;
	readonly text: string;
}

export type DisclaimerType = string | NamedDisclaimer;

export const getDisclaimerText = (disclaimer: DisclaimerType): string | undefined => {
	return typeof disclaimer === 'string' ? disclaimer : disclaimer?.text;
};

export function isStandardReferenceDisclaimer(disclaimer: DisclaimerType): disclaimer is string {
	return typeof disclaimer === 'string';
}

export const useDisclaimerReference = (disclaimers: RegisteredDisclaimer[] | undefined): void => {
	const { disclaimerManager } = useContext(OfertasContext);
	const scopedDisclaimerManager = disclaimerManager.getScopedDisclaimerManager();

	const registerDisclaimer = (disclaimer: RegisteredDisclaimer, registeredDisclaimersMap: RegisteredDisclaimers) => {
		const text = disclaimer.text;

		if (!text) {
			return;
		}

		if (disclaimer.ref) {
			const reference = scopedDisclaimerManager.registerReferenceDisclaimer('footer-reference', text, disclaimer.ref);

			registeredDisclaimersMap[text] = {
				text: disclaimer.text,
				ref: reference,
				type: disclaimer.type,
			};
		} else {
			scopedDisclaimerManager.registerGlobalDisclaimer(text);

			registeredDisclaimersMap[text] = {
				text: disclaimer.text,
				ref: undefined,
				type: disclaimer.type,
			};
		}
	};

	const handlePropsChange = (registeredDisclaimersMap: RegisteredDisclaimers): void => {
		if (disclaimers) {
			disclaimers.forEach((disclaimer) => registerDisclaimer(disclaimer, registeredDisclaimersMap));
		}
	};

	useEffect(() => {
		const registeredDisclaimersMap: RegisteredDisclaimers = {};

		handlePropsChange(registeredDisclaimersMap);
	}, [disclaimers]);
};
